import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { LoginAuthAction } from '../../../redux/actions/AuthAction';
import { ResetErrorHandlerAction } from '../../../redux/actions/ErrorActions';
import AuthStatusUpdate from './AuthStatusUpdate';
import '../../../styles/mainContents.css';
// import authReducer from './../../../redux/reducers/AuthReducer';

function Login(props) {

    const { login, resetErrorHandler, authreducerState } = props;
    
    const [ loginState, setLoginState ] = useState({});
    const history = useHistory();

    const input1Ref = useRef(null);
    const input2Ref = useRef(null);

    return (
                
        <div>
            <AuthStatusUpdate/>
            
            <main>
                <h1>Login</h1>

                <table id='loginTblId'>
                    <thead></thead>
                    <tbody>
                        <tr>
                            <td className='loginTblLabel'>Username/Email Address</td>
                            <td className='loginTblInput'>
                                <input 
                                    type="email" 
                                    id='iUserEmail'  
                                    onChange={(event) => {
                                        const email = event.target.value;
                                        setLoginState({...loginState, ...{email}});
                                    }}
                                    ref={input1Ref}
                                    onKeyPress={ (event) => {
                                        if (event.key === 'Enter') {
                                            input2Ref.current.focus();
                                        }
                                    }}                                    
                                />
                            </td>

                        </tr>
                        <tr>
                            <td className='loginTblLabel'>Password</td>
                            <td className='loginTblInput'>
                                <input 
                                    type="password" 
                                    id='iUserPass' 
                                    ref={input2Ref}
                                    onChange={(event) => {
                                        const password = event.target.value;
                                        setLoginState({...loginState, ...{password}});
                                    }}
                                    onKeyPress={ (event) => {
                                        if (event.key === 'Enter') {
                                            login(loginState); 
                                        }
                                    }}
                                />
                            </td>

                        </tr>                        
                    </tbody>
                </table>

                <div id='loginBtnDivId'>
                    {/* <div>
                        <button onClick={() => {
                            resetErrorHandler()
                            history.push('/register')
                        }}>Register
                        </button>
                    </div>                     */}
                    <div>
                        <button onClick={() => {
                            login(loginState); 
                        }}>Login
                        </button>
                    </div>
                </div>

            </main>

        </div>


    );
}

const mapStateToProps = (state) => {
    return {
        authreducerState: state.authreducer,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        login: (loginState) => {
            dispatch(LoginAuthAction(loginState));
        },
        resetErrorHandler: () => {
            dispatch(ResetErrorHandlerAction());
        }         
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);